import { useNavigate } from 'react-router-dom';
import AuthPage from './AuthPage';

export default function AuthPageRoute() {
  const navigate = useNavigate();
  return <AuthPage onSuccess={() => navigate('/')} standalone />;
}
